import { fork, call, take, put, all } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { unauthorizedAction } from '../actions/authActions'
import {
  getAllCarriersAction,
  getCarrierAction,
  createCarrierAction,
  updateCarrierAction,
  deleteCarrierAction,
} from '../actions/carriersActions'
import {
  showSuccessMessageAction,
  showErrorMessageAction,
} from '../actions/uiActions'
import api from '../services/api'
import { MESSAGES } from '../constants'
import { pickErrorMessage } from '../utils/helpers'

// carriers have no detail page - creating/editing one goes back to the
// list on the inventory page
const CARRIERS_LIST_PATH = '/inventory/all/carriers'

// handlers

function* handleGetAllCarriersSaga(qs) {
  try {
    const payload = yield call(api.getAllCarriers, qs)
    yield put(getAllCarriersAction.success(payload))
  } catch (error) {
    yield put(getAllCarriersAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleGetCarrierSaga(id) {
  try {
    const payload = yield call(api.getCarrier, id)
    yield put(getCarrierAction.success(payload))
  } catch (error) {
    yield put(getCarrierAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleCreateCarrierSaga(carrier) {
  try {
    const payload = yield call(api.createCarrier, carrier)

    yield put(createCarrierAction.success(payload))
    yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_CREATED))
    yield put(push(CARRIERS_LIST_PATH))
  } catch (error) {
    yield put(createCarrierAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleUpdateCarrierSaga(carrier) {
  try {
    const payload = yield call(api.updateCarrier, carrier)
    yield put(updateCarrierAction.success(payload))
    yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_UPDATED))
    yield put(push(CARRIERS_LIST_PATH))
  } catch (error) {
    yield put(updateCarrierAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

function* handleDeleteCarrierSaga(id) {
  try {
    const confirmDeletion = yield call(global.confirm, MESSAGES.CONFIRM)
    if (confirmDeletion) {
      yield call(api.deleteCarrier, id)
      yield fork(handleGetAllCarriersSaga, global.location.search)
      yield put(showSuccessMessageAction(MESSAGES.SUCCESSFULLY_DELETED))
    }
  } catch (error) {
    yield put(deleteCarrierAction.failure(error))
    yield put(showErrorMessageAction(pickErrorMessage(error)))

    if (error.status === 401) {
      yield put(unauthorizedAction())
    }
  }
}

// watchers

function* watchGetAllCarriersSaga() {
  while (true) {
    const { payload: qs } = yield take(getAllCarriersAction.REQUEST)
    yield fork(handleGetAllCarriersSaga, qs)
  }
}

function* watchGetCarrierSaga() {
  while (true) {
    const { payload } = yield take(getCarrierAction.REQUEST)
    yield fork(handleGetCarrierSaga, payload)
  }
}

function* watchCreateCarrierSaga() {
  while (true) {
    const { payload } = yield take(createCarrierAction.REQUEST)
    yield fork(handleCreateCarrierSaga, payload)
  }
}

function* watchUpdateCarrierSaga() {
  while (true) {
    const { payload } = yield take(updateCarrierAction.REQUEST)
    yield fork(handleUpdateCarrierSaga, payload)
  }
}

function* watchDeleteCarrierSaga() {
  while (true) {
    const { payload } = yield take(deleteCarrierAction.REQUEST)
    yield fork(handleDeleteCarrierSaga, payload)
  }
}

function* carriersSaga() {
  yield all([
    fork(watchGetAllCarriersSaga),
    fork(watchGetCarrierSaga),
    fork(watchCreateCarrierSaga),
    fork(watchUpdateCarrierSaga),
    fork(watchDeleteCarrierSaga),
  ])
}

export {
  carriersSaga as default,
  watchGetAllCarriersSaga,
  watchGetCarrierSaga,
  watchCreateCarrierSaga,
  watchUpdateCarrierSaga,
  watchDeleteCarrierSaga,
  handleGetAllCarriersSaga,
  handleGetCarrierSaga,
  handleCreateCarrierSaga,
  handleUpdateCarrierSaga,
  handleDeleteCarrierSaga,
}
